<template>
  <v-select
    v-model="fieldValue"
    class="octa-custom-select"
    :options="options"
    label="name"
    :filterable="false"
    :searchable="false"
    @input="fieldUpdated"
  ></v-select>
</template>

<script>
  // OBSOLETE: Remove this component to new version without ticket
  import services from '@/services'

  import Issue from './emission-field'

  import vSelect from 'vue-select'

  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'TypeField',
    components: {
      'v-select': vSelect
    },
    props: {
      id: {
        type: String,
        required: true
      },
      value: {
        default: '',
        required: false
      }
    },
    data() {
      return {
        options: [],
        fieldValue: ''
      }
    },
    computed: {
      selectedValue() {
        return (
          this.fieldValue ||
          (this.value.fieldId ? this.value.fieldValue : this.value)
        )
      }
    },
    created() {
      services.main.getTicketTypes().then(r => (this.options = r))
    },
    methods: {
      fieldUpdated(value) {
        this.fieldValue = value

        this.$emit('input', Issue.createField(this.id, this.fieldValue, false))
      }
    }
  }
</script>

<style scoped></style>
